import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);     // null = checking, false = guest, object = authed
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    api.get("/auth/me")
      .then((r) => { if (mounted) setUser(r.data); })
      .catch(() => { if (mounted) setUser(false); })
      .finally(() => { if (mounted) setReady(true); });
    return () => { mounted = false; };
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return data;
    };
    const loginBase = async (base, email, password) => {
      const { data } = await api.post("/auth/login-base", { base, email, password });
      setUser(data);
      return data;
    };
    const register = async (payload) => {
      const { data } = await api.post("/auth/register", payload);
      setUser(data);
      return data;
    };
    const logout = async () => {
      await api.post("/auth/logout");
      setUser(false);
    };
    return { user, ready, login, loginBase, register, logout, setUser, refresh };
  }, [user, ready, refresh]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
